import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Routes } from '@angular/router';
import { PublicDataResolver, UserResolver } from "@pos-shared/services/pos-resolvers";
import { Pos2LoginComponent } from './auth/pos2-login.component';


const routes: Routes = [
    // { path: 'kitchen', resolve: { data: PublicDataResolver }, loadChildren: () => import('./kitchen/kitchen.module').then(m => m.KitchenModule) },
    { path: 'kitchen', resolve: { data: PublicDataResolver }, loadChildren: () => import('@pos-shared/kitchen/kitchen.module').then(m => m.KitchenModule) },
    /*{ path: 'public', loadComponent: () => import('./pos2-public/pos2-public-redirect.component')
            .then((c) => c.Pos2PublicRedirectComponent) },
    { path: 'public/:id', loadComponent: () => import('./pos2-public/pos2-public-redirect.component')
            .then((c) => c.Pos2PublicRedirectComponent) },*/

    { path: 'public', loadChildren: () => import('@pos-shared/old-public/pos-old-public.module')
                .then((m) => m.PosOldPublicModule) },
    { path: 'display/:tableId', loadComponent: () => import('./table-info-display/pos2-table-info-display.component')
      .then((c) => c.Pos2TableInfoDisplayComponent) },

    { path: 'numbers', loadComponent: () => import('./table-info-display/pos2-table-info-display-numbers.component')
            .then((c) => c.Pos2TableInfoDisplayNumbersComponent) },
    { path: '', loadComponent: () => import('./app-container.component')
            .then((c) => c.AppContainerComponent), resolve: { user: UserResolver }, children:
            [
            //     { path: 'organizer', loadChildren: () => import('./organizer/organizer.module').then((m) => m.OrganizerModule) },
            //
            //     { path: 'options', component: OptionsComponent },

                {
                    path: 'tables',
                    loadChildren: () => import('./tables/pos2-tables.module').then((m) => m.Pos2TablesModule)
                },
                {
                    path: 'options', loadComponent: () => import('./options/pos2-options.component')
                        .then((c) => c.Pos2OptionsComponent)
                },


                {
                    path: 'organizer', loadComponent: () => import('./organizer/pos2-organizer-container-component')
                        .then((c) => c.Pos2OrganizerContainerComponent), children: [
                        {
                            path: 'reservations', loadComponent: () => import('@pos2/pos2-reservations.component')
                                .then((c) => c.Pos2ReservationsComponent)
                        },
                        {
                            path: 'orders', loadComponent: () => import('@pos-shared/components/pos-orders.component')
                                .then((c) => c.PosOrdersComponent)
                        },
                        {
                            path: 'payments',
                            loadComponent: () => import('@pos-shared/components/pos-order-history.component')
                                .then((c) => c.PosOrderHistoryComponent)
                        },
                        {
                            path: 'consumers',
                            loadComponent: () => import('@pos-shared/components/pos-consumer-tables.component')
                                .then((c) => c.PosConsumerTablesComponent)
                        },
                        {
                            path: 'devices', loadComponent: () => import('@pos-shared/components/pos-devices.component')
                                .then((c) => c.PosDevicesComponent)
                        },
                        {
                            path: 'articles',
                            loadComponent: () => import('@pos-shared/components/pos-articles.component')
                                .then((c) => c.PosArticlesComponent)
                        },
                        {
                            path: 'materials',
                            loadComponent: () => import('@pos-shared/components/pos-materials.component')
                                .then((c) => c.PosMaterialsComponent)
                        },
                    ]
                },


                /*
                { path: 'article-categories', component: PosArticleCategoriesComponent },
                { path: 'articles', component: PosArticlesComponent },
                { path: 'employee', component: PosEmployeesComponent },
                { path: 'tabel', component: PosTabelComponent },
                { path: 'pending', component: PendingOrderComponent },
                { path: 'help', component: HelpComponent },
                /*
                 */
                //     { path: 'tables/:tableId', component: MainComponent },
                //
                //     { path: 'customers', component: CustomersComponent },
                //     { path: 'talk-room', component: TalkRoomComponent },
                //     { path: 'cook', component: CookTablesComponent },
                //
                //     { path: 'customer/login', component: CustomerLoginComponent },
                //     { path: 'customer', component: CustomerContainerNewComponent, resolve: { data: PublicDataResolver }, children:
                //             [
                //                 { path: '', component: CustomerMenuPreviewComponent },
                //                 { path: 'order', component: CustomerProposalPreviewNewComponent,  },
                //                 { path: ':categoryId/items/:productId', component: CustomerItemPreviewComponent, resolve: { article: ArticleResolver, category: ArticleCategoryResolver } },
                //                 { path: ':categoryId', component: CustomerMenuPreviewComponent },
                //             ]
                //     },
                //     { path: 'customer3', component: CustomerContainerNewComponent, },
            ]
    },
    {path: 'login', component: Pos2LoginComponent},
    // { path: 'logout', component: LogoutComponent, },
    {path: '**', redirectTo: ''},

];

@NgModule({
    imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload', enableTracing: false})],
    exports: [RouterModule]
})

export class AppRoutingModule {

}

